import { cookies } from "sharedKernel/cookies/behavior";
import { getCredLocalStorage } from "sharedKernel/auth/credLocalStorage";
import { IUser } from "./contracts/iUser";
import { store } from "store";

interface JWTTokenData {
  user_name?: string;
  userName?: string;
  name?: string;
  user_email?: string;
  email?: string;
  role?: string;
  role_id?: string;
  company_name?: string;
  company_id?: string;
  [key: string]: any;
}
class LoggedUserFactory {
  build(): LoggedUser {
    return new LoggedUser();
  }
}

class LoggedUser {
  get(): IUser {
    const personalInfo = cookies.get("_cred")?.data;
    const credLocalStorage = getCredLocalStorage();
    const profileImage = cookies.get("_profImg");

    let tokenData: JWTTokenData | null = null;
    try {
      if (personalInfo?.token) {
        const tokenPayload = JSON.parse(atob(personalInfo.token.split(".")[1]));
        tokenData = tokenPayload as JWTTokenData;
      }
    } catch (error) {
      console.error("Erro ao decodificar token:", error);
    }

    const userName =
      tokenData?.user_name ||
      tokenData?.userName ||
      tokenData?.name ||
      personalInfo?.name ||
      personalInfo?.userName ||
      personalInfo?.fullName ||
      personalInfo?.user_name ||
      "Usuário";

    const userEmail =
      tokenData?.user_email ||
      tokenData?.email ||
      personalInfo?.email ||
      personalInfo?.userEmail ||
      personalInfo?.user_email ||
      "";

    const userRole =
      tokenData?.role ||
      personalInfo?.role?.name ||
      personalInfo?.role ||
      personalInfo?.userRole ||
      "CaixaEmployee";

    const roleId =
      tokenData?.role_id ||
      personalInfo?.role?.id ||
      personalInfo?.roleId ||
      personalInfo?.role_id ||
      "00000000-0000-0000-0000-000000000000";

    const companyName =
      tokenData?.company_name ||
      credLocalStorage?.company?.name ||
      personalInfo?.companyName ||
      personalInfo?.company_name ||
      "Caixa Econômica Federal";

    const companyId =
      tokenData?.company_id ||
      credLocalStorage?.company?.id ||
      personalInfo?.companyId ||
      personalInfo?.company_id ||
      "00000000-0000-0000-0000-000000000000";

    const userId =
      personalInfo?.id ||
      personalInfo?.userId ||
      personalInfo?.user_id ||
      "00000000-0000-0000-0000-000000000000";

    return {
      id: userId,
      name: userName,
      email: userEmail,
      position: userRole,
      avatar: profileImage,
      // `IUser` declares these three as required (`Date` / `IUser[]` / `boolean`), but the
      // data behind them has always been optional — the `any` from `cookies.get()` used to
      // hide it. `ICredLocalStorage` is typed, so the mismatch surfaces here; casting keeps
      // the exact runtime behaviour instead of loosening the shared interface.
      updatedAt: credLocalStorage?.updatedAt as unknown as Date,
      profiles: credLocalStorage?.profiles as unknown as IUser[],
      isSuperAdmin: (credLocalStorage?.isSuperAdmin ?? false) as boolean,
      role: {
        id: roleId,
        name: userRole,
      },
      company: {
        id: companyId,
        name: companyName,
        logo: profileImage,
        powerBiUrl: credLocalStorage?.powerBiUrl,
      },
      cityHallInfo: credLocalStorage?.cityHallInfo,
    };
  }
}

const factory = new LoggedUserFactory();
export const loggedUser = factory.build();
